import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./BbsDetail.css";
import "./swalStyle.css";
import * as BBSFunctions from "../../../../functions/Functions";
import * as detailsDateFormat from "../../../../components/Util/DateFormat";
import { getServerBaseUrl } from "../../../../utils/portConfig";
import CommunityCommentList from "../../../../components/Comments/CommunityCommentList";
import { onClickFileNewTab } from "../../../../utils/openFileUrl";
import LockIcon from "../../../../assets/icons/lock-01.svg";
import { ReactComponent as Polygon } from "../../../../assets/icons/polygon3.svg";
import Thumbnail from "./CommonThumbnail";

function PatientCommunityDetail({ whenMovingNoticeDetail, setDocorSettingOpen }) {
  const initialBBSDetailData = {
    id: "",
    title: "",
    content: "",
    category: "",
    privatePost: false,
    userId: 0,
    nickname: "",
    createdDt: "",
    modifiedDt: "",
    attachments: [],
    comments: [],
  };

  const navigate = useNavigate();
  const location = useLocation();

  const userid = localStorage.getItem("userid");
  const [bbsDetailData, setBBSDetailData] = useState({ ...initialBBSDetailData }); //게시글-조회, 수정
  // const [isEditor, setIsEditor] = useState(false);
  const [commentList, setCommentList] = useState([]);
  const [deleteFile, setDeleteFile] = useState(false);
  const [category, setCategory] = useState("");
  const [originalData, setOriginalData] = useState({ ...initialBBSDetailData });
  const API_SERVER_V2_URL = `${getServerBaseUrl()}/api/v2`; // API 서버 URL
  const token = localStorage.getItem("token");
  const auth = localStorage.getItem("auth");

  // 에디터 ref 선언
  // const editorRef = useRef(null);

  //게시글 조회
  const getNoticeDetails = async () => {
    try {
      const resData = await BBSFunctions.getPatientCommunityDetail(API_SERVER_V2_URL, token, bbsDetailData.id);
      setCommentList(resData.comments);

      setBBSDetailData({
        ...bbsDetailData,
        id: resData.id,
        title: resData.title,
        content: resData.content,
        category: resData.category,
        privatePost: resData.privatePost,
        userId: resData.userId,
        nickname: resData.nickname,
        createdDt: detailsDateFormat.formatKoreanDateTime(resData.createdDt),
        modifiedDt: resData.modifiedDt,
        attachments: resData.attachments,
        comments: resData.comments,
        mine: resData.mine,
      });

      setOriginalData({
        ...originalData,
        id: resData.id,
        title: resData.title,
        content: resData.content,
        category: resData.category,
        privatePost: resData.privatePost,
        userId: resData.userId,
        nickname: resData.nickname,
        createdDt: detailsDateFormat.formatKoreanDateTime(resData.createdDt),
        modifiedDt: resData.modifiedDt,
        attachments: resData.attachments,
        comments: resData.comments,
        mine: resData.mine,
      });

      // if (resData.attachments && resData.attachments.length > 0) {
      //   BBSFunctions.filePreview(resData.attachments[0], token)
      //     .then((fileUrl) => {
      //       setFilePreviewUrl(fileUrl);
      //     })
      //     .catch((error) => {
      //       console.error("파일 미리보기 오류:", error);
      //     });
      // }
    } catch (error) {
      console.error("게시글 조회 에러:", error);
    }
  };

  useEffect(() => {
    if (location.state && location.state.category) {
      setCategory(location.state?.category);
    }

    if (whenMovingNoticeDetail) {
      bbsDetailData.id = whenMovingNoticeDetail;
      getNoticeDetails();
    }
    // route state 에서 id 가지고 옴
    else if (location.state && location.state.setNoticeDetailId) {
      bbsDetailData.id = location.state.setNoticeDetailId;
      getNoticeDetails();
    }

    return () => {
      setBBSDetailData({ ...initialBBSDetailData });
      setCommentList([]);
      setCategory("");
      setOriginalData({ ...initialBBSDetailData });
    };
  }, [whenMovingNoticeDetail || location.state]);

  const movingNoticePage = () => {
    navigate(auth === "Superadmin" || auth === "Admin" ? "/admin/qna" : "/", { state: { setActiveMenu: "게시판", tabFlag: "환자_커뮤니티" } });
  };

  return (
    <div className="bbs-content-container">
      <div className={"bbs-detail-content-option-container-nEditor"}>
        {bbsDetailData.title}
        {bbsDetailData.privatePost && <img src={LockIcon} />}
      </div>
      <div className="bbs-detail-content-option-container-regInfo">
        <div className="bbs-detail-regInfo" style={{ display: "flex", flexDirection: "row" }}>
          <span className="text-align-left">
            <span className="span-text-style">카테고리&nbsp;</span>
            <span>{category}</span>
          </span>
          <span className="text-align-left">
            <span className="span-text-style">작성일&nbsp;</span>
            <span>{bbsDetailData.createdDt}</span>
          </span>
          <span className="text-align-left">
            <span className="span-text-style">작성자&nbsp;</span>
            <span>{bbsDetailData.nickname || "탈퇴한 회원"}</span>
          </span>
        </div>
      </div>
      {/* <img src={filePreviewUrl} alt="첨부파일 미리보기" className="bbs-detail-file-preview" style={{ display: filePreviewUrl ? "block" : "none" }} /> */}
      {/* {isEditor ? (
          <div className="content-detail-quill-container">
            <Editor ref={editorRef} readOnly={false} initialHTML={bbsDetailData.contents} />
          </div>
        ) : (
          )} */}
      <div className="bbs-detail-contents">{bbsDetailData.content}</div>

      <div className="preview-file-container">
        {bbsDetailData.attachments.length > 0 &&
          bbsDetailData.attachments.map((file, index) => (
            <div style={{ position: "relative" }} key={index} onClick={() => onClickFileNewTab(file.hlsUrl ? file.hlsUrl : file.url, file.hlsUrl !== null)}>
              <Thumbnail file={file.thumbnailUrl} index={index} />
              {file.hlsUrl && (
                <div className="polygon">
                  <Polygon width={20} />
                </div>
              )}
            </div>
          ))}
      </div>

      <div style={{ borderTop: "1px solid lightgray", width: "100%", paddingTop: "5px" }}>
        <div className="notice-detail-button-container">
          <button onClick={movingNoticePage}>목록</button>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div className="comments-box">
          <CommunityCommentList
            postId={bbsDetailData.id}
            commentList={commentList.length > 0 ? commentList : []}
            setCommentList={setCommentList}
            getNoticeDetails={getNoticeDetails}
            userid={userid}
            setDocorSettingOpen={setDocorSettingOpen}
          />
        </div>
      </div>
    </div>
  );
}

export default PatientCommunityDetail;
